import { render, staticRenderFns } from "./added_commit_message.vue?vue&type=template&id=3ff0924b"
import script from "./added_commit_message.vue?vue&type=script&lang=js"
export * from "./added_commit_message.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports